import { Action } from 'redux';
import { TablePaging, TableSorting } from './state';

export enum ActionTypeNames {
    Select = 'Tables/Select',
    Unselect = 'Tables/Unselect',
    SelectAll = 'Tables/SelectAll',
    UnselectAll = 'Tables/UnselectAll',
    ClearSelection = 'Tables/ClearSelection',
    NextPage = 'Tables/NextPage',
    PrevPage = 'Tables/PrevPage',
    GoToPage = 'Tables/GoToPage',
    ChangeItemsPerPage = 'Tables/SetItemsPerPage',

    StorePagingState = 'Tables/StorePagingState',
    StoreSortingState = 'Tables/StoreSortingState',

    Search = 'Tables/Search',

    SetFilter = 'Tables/SetFilter',
    RemoveFilter = 'Tables/RemoveFilter'
}

interface TableAction<T extends ActionTypeNames> extends Action<T> {
    tableKey: string;
}

export type SelectAction = TableAction<ActionTypeNames.Select> & { id: string };
export type UnselectAction = TableAction<ActionTypeNames.Unselect> & { id: string };
export type SelectAllAction = TableAction<ActionTypeNames.SelectAll> & { ids: string[] };
export type UnselectAllAction = TableAction<ActionTypeNames.UnselectAll> & { ids: string[] };
export type ClearSelectionAction = TableAction<ActionTypeNames.ClearSelection> & {};

export type NextPageAction = TableAction<ActionTypeNames.NextPage>;
export type PrevPageAction = TableAction<ActionTypeNames.PrevPage>;
export type GoToPageAction = TableAction<ActionTypeNames.GoToPage> & { pageNumber: number };
export type ChangeItemsPerPageAction =
    TableAction<ActionTypeNames.ChangeItemsPerPage> & { itemsPerPage: number };

export type StorePagingStateAction =
    TableAction<ActionTypeNames.StorePagingState> & { state: Partial<TablePaging> };
export type StoreSortingStateAction =
    TableAction<ActionTypeNames.StoreSortingState> & { state: Partial<TableSorting> };

export type SetFilterAction =
    TableAction<ActionTypeNames.SetFilter> & { key: string, selection: string[] };

export type SearchAction =
    TableAction<ActionTypeNames.Search> & { str: string };

export type RemoveFilterAction = TableAction<ActionTypeNames.RemoveFilter> & { key: string };